/* eslint no-unused-vars: 0 */
import {
  objectTransform,
  storedProcParameters,
  makeResourceFirst,
  handleError,
} from "./apiUtils";
import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";
import getOffsetTime from "../utils/getOffsetTime";
import demoParams from "../__test__/demoParams";
const { demoMode, demoPreviousPostingsResourceId } = demoParams;
import { getTour } from "../api/tourApi";

/**
 * Returns an array of posted schedules that the user can view by calling the api.
 * @param {*} resourceId
 */
export async function getListPostedSchedules(resourceId) {
  const { companyId } = storedProcParameters;
  let listPostedSchedules = await API.graphql(
    graphqlOperation(queries.scheduleApIgetPostedSchedulesList, {
      resourceId,
      companyId,
    })
  );
  return listPostedSchedules.data.scheduleAPIgetPostedSchedulesList;
}

/**
 * Returns the posted schedule selected by the user from the api.
 * @param {*} startDate
 * @param {*} scheduleFormat
 *  @param {*} postedId
 * @param {*g} resourceId
 * @param {*} resourceName
 */
export async function getPostedSchedules(
  startDate,
  scheduleFormat,
  postedId,
  resourceId,
  resourceName
) {
  let regex = /^\d{4}-\d{2}-\d{2}$/;
  var coincidences = regex.exec(startDate||'') || [];
  if(coincidences.length == 1){
    startDate= `${startDate.substring(5,7)}\\${startDate.substring(8,10)}\\${startDate.substring(0,4)}`;
  }
  let response;
  let postedSchedules;
  const variables = {
    startDate, // => input variable is ignored, storedProc returns more accurate startDate (see line 47 below)
    scheduleFormat,
    postedId: postedId,
  };
  if (scheduleFormat === 1 || scheduleFormat === 2) {
    response = await API.graphql(
      graphqlOperation(queries.scheduleApIgetPostedSchedules, variables)
    );
    postedSchedules =
      response.data.scheduleAPIgetPostedSchedules.postedSchedule;
  } else {
    // scheduleFormat === 7 || scheduleFormat === 9
    response = await API.graphql(
      graphqlOperation(queries.scheduleApIgetPostedSchedules, variables)
    );
    postedSchedules =
      response.data.scheduleAPIgetPostedSchedules.postedSchedule;
  }

  startDate = addOffsetToDate(
    response.data.scheduleAPIgetPostedSchedules.startDate
  );
  let userName = response.data.scheduleAPIgetPostedSchedules.userName || "";
  let savedDate = response.data.scheduleAPIgetPostedSchedules.savedDate
    ? addOffsetToDate(response.data.scheduleAPIgetPostedSchedules.savedDate)
    : "";
  let resourceCollectionId =
    response.data.scheduleAPIgetPostedSchedules.resourceCollectionId || null;

  let sortedPostedScheduleArray;
  if (postedSchedules) {
    // transform dayType and assignment arrays into objects for ease of use in generate-items.js
    let postedScheduleArray = objectTransform(postedSchedules);

    // bring resource (user or selectedResource) to the front of the array
    sortedPostedScheduleArray = makeResourceFirst(
      postedScheduleArray,
      resourceId
    );
  } else {
    alert("Theere was a problem parsing the posted schedule.");
  }

  const postedSchedule = {
    resourceId,
    startDate,
    scheduleFormat,
    resourceName,
    userName,
    savedDate,
    resourceCollectionId,
    postedSchedule: sortedPostedScheduleArray,
  };
  const JSONData = response.data.scheduleAPIgetPostedSchedules.JSONData.map(data => {
    data.startDate = response.data.scheduleAPIgetPostedSchedules.startDate
    return data
  })
  return [postedSchedule, JSONData];
}

/**
 * Returns an array of previous posted schedules that the user can view by calling the api.
 * @param {*} resourceId
 */
export async function getListPreviousPostings(resourceId) {
  const { companyId } = storedProcParameters;
  let listPreviousPostingsSchedules = await API.graphql(
    graphqlOperation(queries.scheduleApIgetPreviousPostings, {
      resourceId: demoMode ? demoPreviousPostingsResourceId : resourceId,
      companyId,
    })
  );
  return listPreviousPostingsSchedules.data.scheduleAPIgetPreviousPostings;
}

export async function getResourceCollectionInformation(parameters) {
  let resourceCollectionInformation = await API.graphql(
    graphqlOperation(
      queries.scheduleApIgetResourceCollectionInformation,
      parameters
    )
  )
    .then((data) => {
      let info =
        data.data.scheduleAPIgetResourceCollectionInformation.data[0] || {};
      return info;
    })
    .catch((error) => {
      console.log(error);
    });
  return resourceCollectionInformation;
}

export async function createPostedSchedule(parameters) {
  parameters.ipAddress = "27.0.0.1";
  let response = await API.graphql(
    graphqlOperation(mutations.scheduleApIcreatePostedSchedule, parameters)
  )
    .then((data) => {
      return data.data.scheduleAPIcreatePostedSchedule;
    })
    .catch((error) => {
      let errorMessage;
      for (let x = 0; x < error.errors.length; x++) {
        if (x === 0) {
          errorMessage = error.errors[x].message;
        } else {
          errorMessage += "/" + error.errors[x].message;
        }
      }
      throw Error(errorMessage);
    });
  return response;
}

const addOffsetToDate = (date) => {
  let dateOffset = getOffsetTime(moment(date)._d);
  let offsetDate = moment(date)
    .add(dateOffset, "minutes")
    .format();

  return offsetDate;
};



// WEBPACK FOOTER //
// ./src/api/postedScheduleApi.js